import React from 'react';
import RocketOutlinedIcon from '@mui/icons-material/RocketOutlined';
import { Surface } from '@infoods/lifebase-ui';

import classes from './NoActiveChallenge.module.scss';
import { WidgetEmptyPlaceholder } from '../../../../../shared/components/ui-components';

const NoActiveChallenge = () => {
  return (
    <Surface radius="l" className={classes.container}>
      <WidgetEmptyPlaceholder
        title="No Active Challenges Yet"
        icon={<RocketOutlinedIcon />}
        text="New challenges are coming soon!"
      />
    </Surface>
  );
};

export { NoActiveChallenge };
